import { useQuery } from '@tanstack/react-query'
import { useAuth } from './useAuth'
import { throwOnError } from '../utils/throwOnError'

export const useGetOrganizationUnitsQuery = () => {
  const { authFetch } = useAuth()
  return useQuery({
    queryKey: ['organizationUnits'],
    staleTime: 1000 * 60 * 60 * 24,
    queryFn: async () => {
      const { data, error } = await authFetch().GET(
        '/orgenhet-api/organisasjonsenheter'
      )
      if (error) throwOnError(error)
      return data
    }
  })
}
